import { Injectable } from '@angular/core';
import { ProjectModelService } from '@project/service/project-model.service';
import { ProjectModel } from '@project/model/project.model';
import { ArticleTypeVO, ArticleVO } from '@article/model/vo/article.vo';
import { CentreArticleLocationVO } from '@project/components/article/model/vo/centre-article-location.vo';
import { ArticleManager } from '@article/manager/article.manager';
import { InsertArticleService } from '@project/components/article/service/insert-article.service';

@Injectable({
  providedIn: 'root'
})
export class AdmintoolProjectService {

  constructor(
    private projectModelService: ProjectModelService,
    private projectModel: ProjectModel,
    private articleManager: ArticleManager,
    private insertArticleService: InsertArticleService
  ) { }

  public async clearCurrentArticle(): Promise<void> {
    await this.projectModelService.clearCurrentProject();
    this.projectModel.currentProjectType = "ADMIN";
    this.projectModel.currentProject.name = 'AdminToolProject';
    this.projectModel.isCompositeAdminView = false;
  }

  public async createEmptyArticle(identity: number = -1, articleNo: string = ''): Promise<ArticleVO> {
    await this.clearCurrentArticle();
    const article: ArticleVO = new ArticleVO();
    article.identity = identity;
    article.articleNo = articleNo;
    article.version = 0;
    article.metaElements = [];
    article.connectionRequirements = [];
    article.connectionFeatures = [];
    article.behaviorProperties = [];
    article.plausiProperties = [];
    article.type = new ArticleTypeVO();
    this.articleManager.addArticleToCache(article);
    await this.insertArticleService.insertArticleByArticleLocation(article, new CentreArticleLocationVO());
    return article;
  }
}
